"use client";
import React from "react";
import { Store } from "lucide-react";
import { ICON_SIZE } from "modules/common/components/navigation/Menu";

export function SimpleStoreListSkeleton() {
  return (
    <div
      className="flex w-full flex-col gap-4"
      role="status"
      aria-label="Loading stores"
    >
      {/* Header Skeleton */}
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <div className="skeleton h-6 w-40 rounded-sm"></div>
          <div className="flex items-center gap-2">
            <div className="skeleton h-5 w-8 rounded-full"></div>
            <Store size={ICON_SIZE} className="text-secondary opacity-50" />
          </div>
        </div>
      </div>

      {/* List Items Skeleton */}
      <div className="rounded-box bg-base-100 max-h-[300px] overflow-y-auto">
        <ul className="menu menu-sm w-full p-0">
          {Array.from({ length: 4 }).map((_, index) => (
            <li
              key={index}
              className="border-base-200 border-b last:border-b-0"
            >
              <div className="flex items-center p-3">
                <div className="skeleton mr-2 h-5 w-5 rounded-full"></div>
                <div className="skeleton h-4 w-full max-w-[180px]"></div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default SimpleStoreListSkeleton;
